var App = App || {};

App.Separators = (function ($) {
    "use strict";

    var footerLinks = $("footer .site-footer-links > ul").children("li");

    function init() {
        var separatedElements = [];
        if (footerLinks.length) {
            separatedElements.push(footerLinks);
        }

        applySeparatorsToGroup(separatedElements);

        $(window).resize(function () {
            applySeparatorsToGroup(separatedElements);
        }) 
    }

    function applySeparatorsToGroup(elementGroup) {
        if (elementGroup.length) {
            for (var i = 0; i < elementGroup.length; i++) {
                applySeparators(elementGroup[i])
            }
        }
    }

    function applySeparators(elements) {
        elements.removeClass("separated");
        if (elements.length) {
            var currentLineTop = 0,
                currentItemTop;
            elements.each(function () {
                currentItemTop = $(this).offset().top;
                if (currentItemTop == currentLineTop) {
                    $(this).addClass("separated"); //add separator only if this is not the first item on the line
                } else {
                    currentLineTop = currentItemTop;
                }
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Separators.init();
});